module.exports = __webpack_public_path__ + "assets/images/01HL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01HL.png
// module id = 1254
// module chunks = 1